document.addEventListener('DOMContentLoaded', function () {
    const frame = document.querySelector('.js-sidebar-frame');
    const sidebarAlert = document.querySelector('.js-sidebar-alert');

    if (!frame) return;

    // sidebar form
    const sidebarForm = frame.querySelector('.js-sidebar-form');

    sidebarForm.addEventListener('submit', e => {
        e.preventDefault();

        const name      = sidebarForm.elements['name'];
        const email     = sidebarForm.elements['email'];
        const phone     = sidebarForm.elements['tel'];
        const message   = sidebarForm.elements['text'];

        if (!checkFields(name, email, phone, message)) return;

        console.log('Sidebar Form Data is valid');

        const data = {
            "brand_id":  "TRADEEU",
            "email":     email.value,
            "subject":   "Others",
            "phone":     phone.value,
            "full_name": name.value,
            "message":   message.value
        };

        const success = () => {
            switchAlert();
            sidebarForm.reset();
        };

        const error = (resp) => {
            showWarning(m.trans.get(resp.details.message));
        };

        m.api.send(data, success, error, 'communications/contact-us');
    });

    // sidebar back
    const sidebarBack = document.querySelector('.js-sidebar-back');
    sidebarBack.addEventListener('click', () => switchAlert());


    /**
     * email, phone and message may be undefined
     *
     * @param name
     * @param email
     * @param phone
     * @param message
     * @returns {boolean}
     */
    function checkFields(name, email, phone, message) {
        let flag = true;

        if (!m.validation.fieldName(name)) flag = false;
        if (email !== undefined) !m.validation.email(email) ? flag = false : null;
        if (phone !== undefined) !m.validation.phone(phone) ? flag = false : null;
        if (message !== undefined) !m.validation.message(message, 10) ? flag = false : null;

        return flag;
    }

    /**
     *  switch alert & form state
     */
    function switchAlert() {
        sidebarAlert.classList.toggle('is-active');
        sidebarForm.classList.toggle('is-inactive');
    }

    /**
     * Show warning message
     * @param content
     * @returns {node}
     */
    function showWarning(content) {
        const warning = document.createElement('div');
        warning.className = 'sidebar-frame-warning';
        warning.innerHTML = content;

        const warningClose = document.createElement('button');
        warningClose.className = 'sidebar-frame-warning__close';
        warningClose.addEventListener('click', () => warning.remove());

        warning.append(warningClose);
        sidebarForm.append(warning);

        // hide after 4 seconds
        setTimeout(()=> warning.remove(), 4000);
    }

});
